import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/Buttons';

interface Theme {
  primaryFontColor?: string;
  primaryButtonGradientStart?: string;
}

interface Props {
  quiz: {
    quizName: string;
    quizNameSlug: string;
    logoImage: string;
    startsDate?: string | number;
    endsDate?: string | number;
  };
  theme?: Theme;
  isActive?: boolean;
  onPlay: () => void;
}

const QuizCard: FC<Props> = ({ quiz, theme, isActive = false, onPlay }) => {
  const { t } = useTranslation();
  const now = Date.now();
  const started = !quiz.startsDate || Number(quiz.startsDate) <= now;
  const ended = !!quiz.endsDate && Number(quiz.endsDate) <= now;
  const playable = started && !ended;

  return (
    <div
      className="relative flex items-center gap-3 rounded-xl overflow-hidden p-3 backdrop-blur-sm shrink-0"
      style={{
        background: isActive ? 'rgba(255,255,255,0.13)' : 'rgba(255,255,255,0.07)',
        border: isActive
          ? `2px solid ${theme?.primaryButtonGradientStart || '#e3722d'}`
          : '1px solid rgba(255,255,255,0.12)',
        boxShadow: isActive
          ? `0 0 24px 2px ${theme?.primaryButtonGradientStart || '#e3722d'}55`
          : 'none',
      }}
    >
      <img
        src={quiz.logoImage}
        alt={quiz.quizName}
        className="w-12 h-12 rounded-lg object-cover shrink-0"
        style={{ background: 'rgba(255,255,255,0.1)' }}
      />

      <div className="flex-1 min-w-0">
        <p
          className="font-bold text-sm leading-snug truncate"
          style={{ color: theme?.primaryFontColor || '#fff' }}
        >
          {quiz.quizName}
        </p>
        {quiz.startsDate && (
          <p className="text-white/50 text-xs mt-0.5">
            {new Date(Number(quiz.startsDate)).toLocaleDateString(undefined, {
              day: 'numeric', month: 'short', year: 'numeric',
            })}
          </p>
        )}
      </div>

      {playable ? (
        <Button
          className="shrink-0 primary-button capitalize"
          onClick={onPlay}
          size="small"
        >
          {t('buttons.playNow')}
        </Button>
      ) : !started ? (
        <span className="shrink-0 px-4 py-2 rounded-xl text-xs font-semibold text-white/40 border border-white/20">
          {t('labels.soon')}
        </span>
      ) : ended ? (
        <span className="shrink-0 px-4 py-2 rounded-xl text-xs font-semibold text-white/30 border border-white/10">
          {t('labels.ended')}
        </span>
      ) : null}
    </div>
  );
};

export default QuizCard;
